module.exports = __webpack_public_path__ + "img/809.b8b20381.png";